import angular from 'angular';
const componentOptions = {
    bindings: {
    },
    controllerAs : 'subscriptionModelsGenericErrorCtrl',
    templateUrl: ['SubscriptionModelsAppConstants', (SubscriptionModelsAppConstants: SubscriptionModelsAppConstant): string => `${SubscriptionModelsAppConstants.templatesRoute}ib-subscription-models-generic-error-view.html`]
};
const componentInfo = {
    module: 'ib-subscription-models-generic-error-module',
    selector: 'ibSubscriptionModelsGenericError',
    inject: ['SubscriptionModelsAppConstants', 'NewMainHeaderFacade', '$rootScope'],
    required: []
};
class ibSubscriptionModelsGenericError implements ng.IController {
    constructor ( private SubscriptionModelsAppConstants: SubscriptionModelsAppConstant,  private NewMainHeaderFacade: any,
        private $rootScope: CommonsRootScope) {
        this.active();
    }
    active = ():void => {
        this.NewMainHeaderFacade.initHeader(
            {
                originDestination:null,
                redemption: '',
                flightType: null,
                currency: '',
                showBasket: false
            },
            { hasSteps: false, steps: this.SubscriptionModelsAppConstants.STEPS.STEPS, position: this.SubscriptionModelsAppConstants.STEPS.HOME },
            {
                onLogin: function () {

                }, onError: (error: any) => {

                }, afterLogin: () => { },
                userLogged: false,
                loggedData: undefined,
                show: false
            }
        );
        this.$rootScope.fullWidth = true;
    };
}
try {
    const mod = angular.module(componentInfo.module);
    ibSubscriptionModelsGenericError.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibSubscriptionModelsGenericError })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibSubscriptionModelsGenericError.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibSubscriptionModelsGenericError })
    );
}